import { render, staticRenderFns } from "./measureUnit.vue?vue&type=template&id=de996e24&scoped=true&"
import script from "./measureUnit.vue?vue&type=script&lang=js&"
export * from "./measureUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de996e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de996e24')) {
      api.createRecord('de996e24', component.options)
    } else {
      api.reload('de996e24', component.options)
    }
    module.hot.accept("./measureUnit.vue?vue&type=template&id=de996e24&scoped=true&", function () {
      api.rerender('de996e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/measureUnit.vue"
export default component.exports